import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Table,
} from 'reactstrap';
import { ProperAssignedVisit } from '../models/dashboardModels';
import {
  IconCalendar,
  IconChevronRight,
  IconClock,
  IconMail,
  IconMapPin,
  IconPhone,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import VisitMarketplaceTypeBadge from '../../../components/VisitMarketplaceTypeBadge';
import { VISIT_STATUS } from '../../../constants/visitsConstants';
import PreSaleFeedbackPill from './PreSaleFeedbackPill';
import RentSecondaryVisitBadge from '../../../components/badges/RentSecondaryVisitBadge';

export interface Props {
  visits: ProperAssignedVisit[];
  footer?: any;
  selectedVisitId?: string | null;
  onSelectVisit?: (visitId: string) => void;
}

// Visitas del Proper: las acciones (marcar como realizada, cancelar) viven en
// el detalle.
const DashboardVisitListTable = ({
  visits,
  footer,
  selectedVisitId,
  onSelectVisit,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Card className="dv2-table">
      <CardHeader>
        <CardTitle>Visitas</CardTitle>
      </CardHeader>
      <CardBody>
        <div className="table-responsive">
          <Table striped hover>
            <thead>
              <tr>
                <th>Propiedad</th>
                <th>Inquilino</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {visits.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-center text-muted">
                    No hay visitas registradas.
                  </td>
                </tr>
              )}
              {visits.map((visit) => (
                <tr
                  key={visit.id}
                  className={visit.id === selectedVisitId ? 'is-selected' : ''}
                  onClick={() => onSelectVisit?.(visit.id)}
                >
                  <td>
                    <div className="font-weight-bold">
                      [{visit.propertyInfo.code}] {visit.propertyInfo.name}
                    </div>
                    <div className="d-flex align-items-center text-muted small">
                      <IconMapPin size={12} className="me-1" />
                      {visit.propertyInfo.address}
                    </div>
                    <div className="text-success font-weight-bold">
                      {visit.propertyInfo.price}
                    </div>
                    <VisitMarketplaceTypeBadge
                      marketplace_type={visit.visitInfo.marketplace_type}
                    />
                  </td>
                  <td>
                    <div className="font-weight-bold">
                      {visit.visitInfo.tenant_name}
                    </div>
                    <div className="d-flex align-items-center text-muted">
                      <IconMail size={12} className="me-1" />{' '}
                      {visit.visitInfo.tenant_email}
                    </div>
                    <div className="d-flex align-items-center text-muted">
                      <IconPhone size={12} className="me-1" />
                      {visit.visitInfo.tenant_phone}
                    </div>
                    <div className="d-flex align-items-center font-weight-bold">
                      <IconCalendar size={12} className="me-1" />
                      {visit.visitInfo.visit_date}
                    </div>
                    <div className="d-flex align-items-center font-weight-bold">
                      <IconClock size={12} className="me-1" />
                      {visit.visitInfo.visit_time}
                    </div>
                  </td>
                  <td>
                    <RentSecondaryVisitBadge
                      status={visit.visitInfo.status}
                      className="badge-lg mr-2"
                    />
                    {visit.visitInfo.status === VISIT_STATUS.DONE && (
                      <PreSaleFeedbackPill
                        visitId={visit.id}
                        pending={visit.visitInfo.has_feedback === false}
                      />
                    )}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="dv2-detail-link"
                      onClick={(event) => {
                        event.stopPropagation();
                        navigate(`/dashboard/rent-visits/${visit.id}`, {
                          state: { visit },
                        });
                      }}
                    >
                      Ver detalle
                      <IconChevronRight size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
      <CardFooter>{footer && <div>{footer}</div>}</CardFooter>
    </Card>
  );
};

export default DashboardVisitListTable;
